document.addEventListener("DOMContentLoaded", () => {
  const bgSlider = new Swiper('.bg-slider', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.bg-slide__next',
      prevEl: '.bg-slide__prev',
    },
    on: {
      realIndexChange: function() {
        const vectors = document.querySelectorAll('#vectorsWrapper .vector-wrapper');
        const vectorsMobile = document.querySelectorAll('#vectorsMobileWrapper .vector-wrapper');

        if (vectors.length && vectorsMobile.length) {
          [...vectors, ...vectorsMobile].forEach(item => {
            parseInt(item.dataset.id) === this.activeIndex
              ? item.classList.remove('hidden')
              : item.classList.add('hidden')
          });
        }
      }
    }
  });
});
